
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/build/repo/.nuxt/app-configs/cfg1.ts"
import cfg1 from "/opt/build/repo/.nuxt/app-configs/cfg2.ts"
import cfg2 from "/opt/build/repo/.nuxt/app-configs/cfg3.ts"
import cfg3 from "/opt/build/repo/.nuxt/app-configs/cfg4.ts"
import cfg4 from "/opt/build/repo/.nuxt/app-configs/cfg5.ts"
import cfg5 from "/opt/build/repo/.nuxt/app-configs/cfg6.ts"
import cfg6 from "/opt/build/repo/.nuxt/app-configs/cfg7.ts"
import cfg7 from "/opt/build/repo/.nuxt/app-configs/cfg8.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, cfg4, cfg5, cfg6, cfg7, inlineConfig)
